export const CUSTOMER_IMPORT_TEMPLATE = `first_name,last_name,email,dob,phone
Julia,Martin,julia.martin@domain.edu,1996-10-28,+15551234567
John,Smith,john.smith@example.com,1990-05-15,+15559876543`;

export const CUSTOMER_IMPORT_FOOTER =
  'CSV only. Columns must match our template: first_name, last_name, email, dob, phone (optional).';

const downloadCsv = (content: string, filename: string) => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => URL.revokeObjectURL(url), 0);
};

export const downloadCustomerImportTemplate = () => {
  downloadCsv(CUSTOMER_IMPORT_TEMPLATE, 'eon-customer-import-template.csv');
};

export const downloadErrorReportCsv = (
  csv: string,
  sourceFilename?: string | null
) => {
  const baseName = sourceFilename?.replace(/\.csv$/i, '') ?? 'customer_import';
  downloadCsv(csv, `${baseName}_errors.csv`);
};

export const buildFallbackErrorReportCsv = (
  errors: Array<{ row: number; message: string }>
) => {
  if (!errors.length) {
    return null;
  }

  const escapeCsvField = (value: string) => {
    if (/[",\n]/.test(value)) {
      return `"${value.replace(/"/g, '""')}"`;
    }

    return value;
  };

  return [
    'row,error',
    ...errors.map((error) => `${error.row},${escapeCsvField(error.message)}`),
  ].join('\n');
};
